.selection {
  transition: fill-opacity 0.3s;
}
